import StateInterface from "../state-interface";

export const bbm_scheduled_push_notification_log: StateInterface["bbm_scheduled_push_notification_log"] = {
	_id: "",
	idempotency_key: "",
	event_key: "",
	notification_template_id: "",
	notification_template_key: "",
	notification_type: "",
	entity_type: "",
	entity_id: "",
	triggered_by: {
		is_system: false,
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
	},
	source: "",
	receiver: {
		is_business_profile: false,
		user_id: "",
		business_profile_id: "",
	},
	channels: {
		in_app: { status: "", reason: "", notification_id: null },
		push: { status: "", reason: "", message_id: "" },
		whatsapp: { status: "", reason: "", template_id: null, content_template_sid: "", message_id: "" },
		email: { status: "", reason: "", message_id: "" },
		sms: { status: "", reason: "", dlt_template_id: null, dlt_sms_record_id: null },
	},
	expires_at: null,
	created_at: "",
	updated_at: "",
};

export default bbm_scheduled_push_notification_log;
